module.exports = __webpack_public_path__ + "img/BO.6b039cbd.svg";